var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcXShield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5255 3.05286L6.52547 1.05286C6.45601 1.0181 6.3794 1 6.30172 1C6.22405 1 6.14744 1.0181 6.07797 1.05286L2.07797 3.05286C2.00261 3.09074 1.93803 3.14703 1.89022 3.21651C1.84241 3.286 1.81291 3.36644 1.80447 3.45036C1.79897 3.50386 1.32397 8.83386 6.09897 10.9574C6.1628 10.9861 6.23199 11.0009 6.30197 11.0009C6.37196 11.0009 6.44115 10.9861 6.50497 10.9574C11.28 8.83386 10.805 3.50436 10.7995 3.45036C10.791 3.36637 10.7615 3.28589 10.7136 3.21639C10.6657 3.14689 10.601 3.09063 10.5255 3.05286ZM6.30197 9.94886C2.91797 8.31286 2.75747 4.82136 2.78497 3.81786L6.30197 2.05936L9.81647 3.81686C9.83547 4.81136 9.65247 8.32586 6.30197 9.94886Z",
    fill: "#FC5555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43164 4.14648L6.28514 5.29298L5.13864 4.14648L4.43164 4.85348L5.57814 5.99998L4.43164 7.14648L5.13864 7.85348L6.28514 6.70698L7.43164 7.85348L8.13864 7.14648L6.99214 5.99998L8.13864 4.85348L7.43164 4.14648Z",
    fill: "#FC5555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcXShield);
export default __webpack_public_path__ + "static/media/ic_xShield.caf5c4b64f895ef41c957533a6b67ab5.svg";
export { ForwardRef as ReactComponent };